export const florida = {
  "12000": "Florida",
  "12001": "Alachua County",
  "12003": "Baker County",
  "12005": "Bay County",
  "12007": "Bradford County",
  "12009": "Brevard County",
  "12011": "Broward County",
  "12013": "Calhoun County",
  "12015": "Charlotte County",
  "12017": "Citrus County",
  "12019": "Clay County",
  "12021": "Collier County",
  "12023": "Columbia County",
  "12025": "Dade County",
  "12027": "DeSoto County",
  "12029": "Dixie County",
  "12031": "Duval County",
  "12033": "Escambia County",
  "12035": "Flagler County",
  "12037": "Franklin County",
  "12039": "Gadsden County",
  "12041": "Gilchrist County",
  "12043": "Glades County",
  "12045": "Gulf County",
  "12047": "Hamilton County",
  "12049": "Hardee County",
  "12051": "Hendry County",
  "12053": "Hernando County",
  "12055": "Highlands County",
  "12057": "Hillsborough County",
  "12059": "Holmes County",
  "12061": "Indian River County",
  "12063": "Jackson County",
  "12065": "Jefferson County",
  "12067": "Lafayette County",
  "12069": "Lake County",
  "12071": "Lee County",
  "12073": "Leon County",
  "12075": "Levy County",
  "12077": "Liberty County",
  "12079": "Madison County",
  "12081": "Manatee County",
  "12083": "Marion County",
  "12085": "Martin County",
  "12087": "Monroe County",
  "12089": "Nassau County",
  "12091": "Okaloosa County",
  "12093": "Okeechobee County",
  "12095": "Orange County",
  "12097": "Osceola County",
  "12099": "Palm Beach County",
  "12101": "Pasco County",
  "12103": "Pinellas County",
  "12105": "Polk County",
  "12107": "Putnam County",
  "12109": "St. Johns County",
  "12111": "St. Lucie County",
  "12113": "Santa Rosa County",
  "12115": "Sarasota County",
  "12117": "Seminole County",
  "12119": "Sumter County",
  "12121": "Suwannee County",
  "12123": "Taylor County",
  "12125": "Union County",
  "12127": "Volusia County",
  "12129": "Wakulla County",
  "12131": "Walton County",
  "12133": "Washington County",
};
